//DEV
/*
export default {
  secret: 'hv86aedUOkg.cwA.kYI.BhIyVJou8RI5MhffUliFE-7apKZ3gqBxb1Vp7wp3Ot0',
  from: {
    id: 'CHANEL_DEV',
    name: 'CHANEL_DEV',
  },
  logoUrl: '/img/bot_gif/profile-pic.png',
}
 */
//PROD


export default {
  secret: 'GPhDijIWdBs.cwA.Zm4.vCpSCS4g709DXAVp7IKcVF1h9k9Gi3CPeV_RU3Eyyu0',
  from: {
    id: 'CHANEL_PROD',
    name: 'CHANEL_PROD',
  },
  logoUrl: '/img/bot_gif/profile-pic.png',
}




// WEBPACK FOOTER //
// ./src/config/directline.js